(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/match.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/match.js'); 
'use strict';

svs.maltipset.models.Match = Backbone.Model.extend({
  initialize: function() {
    this.set(svs.maltipset.models.tipsInfo.toJSON());
    this.set(
      'tipsInfoIsActive',
      svs.maltipset.models.tipsInfo.tipsInfoActive(),
      { silent: true }
    );
    this.listenTo(
      svs.maltipset.models.tipsInfo,
      'change',
      this.tipsInfoChanged,
      this
    );
    this.setSportInLeague();
    this.removeTipsInfoData();
    this.setTioTidningar();
  },
  tipsInfoChanged: function(tipsInfo) {
    this.set('tipsInfoIsActive', tipsInfo.tipsInfoActive(), { silent: true });
    this.set(tipsInfo.toJSON());
  },
  markChanged: function(mark) {
    var markedMatches = this.get('matchesMarked');
    if (mark) {
      markedMatches++;
    } else if (markedMatches > 0) {
      markedMatches--;
    }
    this.set('matchesMarked', markedMatches);
  },
  defaults: function() {
    return {
      matchesMarked: 0
    };
  },
  setSportInLeague: function() {
    var match = this.get('match');

    if (match) {
      match.league = match.league || {};
      match.league.sport = match.league.sport || {};

      if (_.isUndefined(match.league.sport.id)) {
        match.league.sport.id = svs.maltipset.constants.SPORT_ID.SOCCER;
        match.league.sport.name = 'Fotboll';
      }
    }
  },

  getTeamIds: function() {
    var participants = this.get('match').participants;
    return { homeTeamId: participants[0].id, awayTeamId: participants[1].id };
  },

  setTipsInfoData: function() {
    var homeTeam = this.get('match').participants[0],
      awayTeam = this.get('match').participants[1],
      homeTeamTipsInfo = svs.maltipset.collections.tipsInfoDataCollections.getTipsInfoDataByTeamId(
        homeTeam.id
      ),
      awayTeamTipsInfo = svs.maltipset.collections.tipsInfoDataCollections.getTipsInfoDataByTeamId(
        awayTeam.id
      );

    homeTeam.goalAvg = homeTeamTipsInfo.get('goalAverage');
    homeTeam.trend = homeTeamTipsInfo.get('trend');

    awayTeam.goalAvg = awayTeamTipsInfo.get('goalAverage');
    awayTeam.trend = awayTeamTipsInfo.get('trend');

    this.trigger('tipsInfoDataSet');
  },

  removeTipsInfoData: function() {
    if (this.get('match') !== null) {
      _.each(this.get('match').participants, function(team) {
        team.latest = undefined;
        team.goalAvg = undefined;
        team.trend = undefined;
      });
    }
  },

  setTioTidningar: function() {
    var tioTidningar =
        this.get('tioTidningar') || this.get('tioTidningarsTips');
    this.set('tioTidningar', tioTidningar, { silent: true });
  }
});

 })(window);